import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE } = ROLES;

const ALLOWED_ROLES_VIEW_BALANCE = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE];

export function canViewBalance(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_BALANCE);
}
